module.exports = __webpack_public_path__ + "static/media/token1.e953166d.png";